import { render } from "./LoadGame.vue?vue&type=template&id=5f1a1450"
import script from "./LoadGame.vue?vue&type=script&lang=js"
export * from "./LoadGame.vue?vue&type=script&lang=js"

import exportComponent from "/home/magpie/dnd/client/gamemasterai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__